module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoBAMAAAB+0KVeAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAhUExURUdwTJMa95MY9ZMa9ZMY9ZEY9ZMY9ZUa9ZMa9ZMS9ZMc9RIfiBAAAAAKdFJOUwBAwWDxn9EwgBphcjADAAAAwklEQVQoz2NggALOENcJDOigZNUqd3Qxdq9Vq5YUoAmKrAICR1Qx5lVgYIAiaAURXIxFIapSK5jgYiwKkZV2IQRXwMRYVyGBAKhgFLLgUiwKYUqjUAWXYlEIVsqZhS64bAID2yoMkIDsRoRbszAFlzGswgKwq5TCFFzIwOyFLrYEGFLsYmh2g6OPCV0zAcElhoJaGILLYQxkwQRYVCELKjAwMA4CwZVgQQ5UQQdIFvBCEWxASogwwaWwTBCCEFwGSosA1gZF4+Fs2VsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/h5/tabBar_icon_01_active.png
// module id = h8oX
// module chunks = 34